import { render } from "./ImportCompensazioni.vue?vue&type=template&id=53e02de3&scoped=true"
import script from "./ImportCompensazioni.vue?vue&type=script&lang=js"
export * from "./ImportCompensazioni.vue?vue&type=script&lang=js"

import "./ImportCompensazioni.vue?vue&type=style&index=0&id=53e02de3&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e02de3"]])

export default __exports__